import axios from 'axios';
export var tokenKey = '_auth';
var axiosInstance = axios.create();
axiosInstance.defaults.headers.post['Content-Type'] = 'application/json';
axiosInstance.interceptors.request.use(function (config) {
    var token = localStorage.getItem(tokenKey);
    if (token && config.headers) {
        config.headers.Authorization = "Bearer ".concat(token);
    }
    /*    if (window?.location?.hostname.includes('dev.majeures')) {
      console.log('Preprod environment detected. Using basic auth for API requests.');
      config.auth = {
        username: 'adeliom',
        password: '@deliom2025!',
      };
    } */
    return config;
}, function (error) {
    return Promise.reject(error);
});
export default axiosInstance;
